import { render, staticRenderFns } from "./ScheduledMessage.vue?vue&type=template&id=b3b852fe&scoped=true&"
import script from "./ScheduledMessage.vue?vue&type=script&lang=js&"
export * from "./ScheduledMessage.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledMessage.vue?vue&type=style&index=0&id=b3b852fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b852fe",
  null
  
)

export default component.exports